// Edit this file to add, remove, reorder, or update faculty members for this department.
const facultyData = {
  "hod": {
    "id": "f-vinod-naik",
    "name": "Dr. Vinod Naik",
    "designation": "HOD and Associate Professor",
    "role": "HOD and Associate Professor",
    "qualification": "M.Sc., Ph.D.",
    "qualifications": "M.Sc., Ph.D.",
    "image": "/FacultyCImages/DR_vinod_naik_BSH.jpeg",
    "email": "vhn@klsvdit.edu.in",
    "phone": "+91 88843 24070",
    "showPhone": true,
    "experience": "14 years",
    "description": "Dr. Vinod Naik is an Associate Professor in the Department of Chemistry with a Ph.D. in Inorganic Chemistry. His research focuses on inorganic and coordination chemistry. He has published 14 research papers in reputed international journals and successfully guided two scholars to earn their Ph.D. degrees under his supervision.",
    "bio": "Dr. Vinod Naik is an Associate Professor in the Department of Chemistry with a Ph.D. in Inorganic Chemistry. His research focuses on inorganic and coordination chemistry. He has published 14 research papers in reputed international journals and successfully guided two scholars to earn their Ph.D. degrees under his supervision.",
    "specializations": [
      "Coordination Chemistry",
      "Molecular Docking Studies",
      "Synthetic Organic Chemistry"
    ],
    "areas": [
      "Coordination Chemistry",
      "Molecular Docking Studies",
      "Synthetic Organic Chemistry"
    ],
    "courses": [
      "Engineering Chemistry For Computer Science (CS) Stream",
      "Engineering Chemistry For Computer Science (CS) Electrical Stream",
      "Research Samaskratika Kannada"
    ],
    "publications": 14,
    "projects": 0,
    "linkedin": "https://www.linkedin.com/in/dr-vinod-naik-4975aa2b0/",
    "irins": "https://klsvdit.irins.org/profile/268848",
    "recognition": [
      "Published 14 Research papers in Reputed Journals and Under my Guidance awarded 02 Phd"
    ]
  },
  "members": [
    {
      "id": "f-sneha-s-kulkarni",
      "name": "Dr. Sneha S. Kulkarni",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Sc., Ph.D.",
      "qualifications": "M.Sc., Ph.D.",
      "image": "/FacultyCImages/DR_sneha_kulkarni_BSH.jpeg",
      "email": "ssk@klsvdit.edu.in",
      "phone": "+91 99861 33660",
      "showPhone": false,
      "experience": "15 years",
      "description": "Dr. Sneha S. Kulkarni completed her B.Sc. (2009) and M.Sc. in Organic Chemistry (2011) from Karnataka University, Dharwad, and earned her Ph.D. from VTU, Belagavi, in 2023. She has 15 years of teaching experience and has published 10 research papers in reputed national and international journals.",
      "bio": "Dr. Sneha S. Kulkarni completed her B.Sc. (2009) and M.Sc. in Organic Chemistry (2011) from Karnataka University, Dharwad, and earned her Ph.D. from VTU, Belagavi, in 2023. She has 15 years of teaching experience and has published 10 research papers in reputed national and international journals.",
      "specializations": [
        "Novel heterocycle synthesis",
        "biofuels",
        "organic chemistry",
        "nano materials"
      ],
      "areas": [
        "Novel heterocycle synthesis",
        "biofuels",
        "organic chemistry",
        "nano materials"
      ],
      "courses": [
        "Engineering Chemistry For Computer Science And Engineering (CSE) Branch",
        "Electrical And Electronics Engineering (EEE)",
        "Mechanical Engineering (ME) And Civil Branch",
        "Environmental Studies"
      ],
      "publications": 10,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/dr-sneha-kulkarni-7a127a3a9?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "irins": "https://klsvdit.irins.org/profile/266455",
      "recognition": [
        "She received the Best Research Paper Award at the Global Nexus International Conference in recognition of her research contributions",
        "Cultural committee member",
        "News letter committee member",
        "Eco Club member"
      ]
    },
    {
      "id": "f-mallikarjun-k-patil",
      "name": "Dr. Mallikarjun K. Patil",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Sc., Ph.D.",
      "qualifications": "M.Sc., Ph.D.",
      "image": "/FacultyCImages/DR_mallikarjun_patil_BSH.jpeg",
      "email": "mkp@klsvdit.edu.in",
      "phone": "+91 80953 22215",
      "showPhone": false,
      "experience": "10 years",
      "description": "Dr. Mallikarjun K. Patil is an Assistant Professor of Physics at KLS VDIT, Haliyal, and earned his Ph.D. from Karnatak University, Dharwad. He has published over 45 research papers, with 500+ citations, an h-index of 12, and an i10-index of 14. A recipient of the Indian Science Congress Young Scientist Award (2020), he has over seven years of teaching and ten years of research experience.",
      "bio": "Dr. Mallikarjun K. Patil is an Assistant Professor of Physics at KLS VDIT, Haliyal, and earned his Ph.D. from Karnatak University, Dharwad. He has published over 45 research papers, with 500+ citations, an h-index of 12, and an i10-index of 14. A recipient of the Indian Science Congress Young Scientist Award (2020), he has over seven years of teaching and ten years of research experience.",
      "specializations": [
        "Time resolved spectroscopy",
        "Nanomaterial based sensors",
        "Fluorescence Resonance Energy Transfer (FRET) / Surface Energy Transfer (SET) using nanoparticles-dye systems",
        "Solute-solvent interaction using fluorescent dyes"
      ],
      "areas": [
        "Time resolved spectroscopy",
        "Fluorescence Resonance Energy Transfer (FRET) / Surface Energy Transfer (SET) using nanoparticles-dye systems",
        "Nanomaterial based sensors",
        "Solute-solvent interaction using fluorescent dyes"
      ],
      "courses": [
        "Quantum Physics And Applications",
        "Electrical Engineering Materials",
        "Research Methodology & Intellectual Property Rights",
        "Soft Skills"
      ],
      "publications": 45,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/mallikarjun-k-patil-6717571a0/",
      "irins": "https://klsvdit.irins.org/profile/710355",
      "recognition": [
        "Indian Science Congress Young Scientist Award (2020) Awarded by the Indian Science Congress Association, a premier scientific body under the Department of Science and Technology (DST), Government of India",
        "Department of Science and Technology (DST) Doctor of Philosophy (Ph.D.) Fellowship Award (2020-2021) Received the Department of Science and Technology (DST), Government of Karnataka Doctor of Philosophy (Ph.D.) Fellowship, recognizing research excellence and supporting advanced doctoral research in the field of fluorescence spectroscopy and nanomaterials",
        "Society of Photo-Optical Instrumentation Engineers (SPIE) Officers' Travel Grant Award (2020) Selected by Society of Photo-Optical Instrumentation Engineers (SPIE) - The International Society for Optics and Photonics to participate in Photonics West 2020, held in San Diego, California, USA",
        "Qualification in Karnataka State Eligibility Test (K-SET) for Assistant Professorship (2018)",
        "Best Publication Awards from Karnatak University, Dharwad (2018 and",
        "as a collaborative author",
        "Founding President of the Society of Photo-Optical Instrumentation Engineers (SPIE) Karnatak University Student Chapter (2019-2021)",
        "Life Membership in the Indian Science Congress Association",
        "Member of International Society for Optics and Photonics (Society of Photo-Optical Instrumentation Engineers (SPIE))",
        "Early career member of Optica (OPTICA), formerly Optical Society of America (OSA)",
        "Best Paper Presentation Award at the 1st Asia Pacific Conference on Engineering, Education, Social Science and Humanities (APCEESH), Thailand,",
        "8. Best Paper Presentation Award at the National Conference on \"The 100 Years of Quantum Physics: Developments and Multidisciplinary Applications in Novel Materials (NCQP-2026)\" Karnatak University, Dharwad 2026"
      ]
    },
    {
      "id": "f-sameer-m-galagali",
      "name": "Dr. Sameer. M. Galagali",
      "designation": "Associate Professor",
      "role": "Associate Professor",
      "qualification": "M.Sc., Ph.D.",
      "qualifications": "M.Sc., Ph.D.",
      "image": "/FacultyCImages/DR_sameer_galagali_BSH.jpeg",
      "email": "smg@klsvdit.edu.in",
      "phone": "+91 99161 86186",
      "showPhone": false,
      "experience": "25 years",
      "description": "Dr. Sameer M. Galagali serves as Associate Professor of Physics at KLS Vishwanathrao Deshpande Institute of Technology, Haliyal. His work explores the fundamental physics of semiconductor nano-structures, electron transport, and quantum phenomena underlying modern electronic technologies. He is committed to fostering scientific inquiry, academic excellence, and innovation through research and scholarly engagement.",
      "bio": "Dr. Sameer M. Galagali serves as Associate Professor of Physics at KLS Vishwanathrao Deshpande Institute of Technology, Haliyal. His work explores the fundamental physics of semiconductor nano-structures, electron transport, and quantum phenomena underlying modern electronic technologies. He is committed to fostering scientific inquiry, academic excellence, and innovation through research and scholarly engagement.",
      "specializations": [
        "Semiconductor Nano-structures and Nano-materials",
        "Quantum Transport and Charge Carrier Dynamics",
        "Nano-scale Electronic Devices and Device Physics",
        "Theoretical and Computational Condensed Matter Physics"
      ],
      "areas": [
        "Semiconductor Nano-structures and Nano-materials",
        "Quantum Transport and Charge Carrier Dynamics",
        "Nano-scale Electronic Devices and Device Physics",
        "Theoretical and Computational Condensed Matter Physics"
      ],
      "courses": [
        "Quantum Physics And Applications",
        "Physics For Sustainable Structures",
        "Physics Of Materials",
        "Quantum Physics And Electronic Sensors"
      ],
      "publications": 6,
      "projects": 1,
      "linkedin": "https://www.linkedin.com/in/dr-sameer-galagali-06981572/",
      "irins": "https://klsvdit.irins.org/profile/249257",
      "recognition": [
        "Coordinator and Host of All India Council for Technical Education (AICTE)-sponsored All India Council for Technical Education (AICTE) Training and Learning (ATAL) Faculty Development Programmes",
        "Resource Person for invited lectures on emerging areas of Physics and Semiconductor Technology",
        "Researcher in Semiconductor Nano-structures and Quantum Transport"
      ]
    },
    {
      "id": "f-meenal-m-kaliwal",
      "name": "Dr. Meenal M. Kaliwal",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Sc., Ph.D.",
      "qualifications": "M.Sc., Ph.D.",
      "image": "/FacultyCImages/DR_meenal_kaliwal_BSH.jpeg",
      "email": "mmk@klsvdit.edu.in",
      "phone": "+91 95910 45062",
      "showPhone": false,
      "experience": "19 years",
      "description": "Dr. Meenal M. Kaliwal is an Assistant Professor with 19 years of teaching experience. Her research focuses on Graph Theory and its generalizations and she currently guides a Ph.D. scholar. She is skilled in Research, MATLAB and Python and also serves as Chairperson of the Internal Complaints Committee and Women's Cell.",
      "bio": "Dr. Meenal M. Kaliwal is an Assistant Professor with 19 years of teaching experience. Her research focuses on Graph Theory and its generalizations and she currently guides a Ph.D. scholar. She is skilled in Research, MATLAB and Python and also serves as Chairperson of the Internal Complaints Committee and Women's Cell.",
      "specializations": [
        "Graph Theory",
        "Discrete Mathematics"
      ],
      "areas": [
        "Graph Theory",
        "Discrete Mathematics"
      ],
      "courses": [
        "Differential Calculus & Linear Algebra",
        "Calculus",
        "Laplace Transform & Numerical Techniques",
        "Applied Mathematics"
      ],
      "publications": 10,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/dr-meenal-kaliwal-b96304326/?lipi=urn%3Ali%3Apage%3Ap_mwlite_search_srp_all%3B4oGKaXNiTeGJzH0oSHw4uQ%3D%3D",
      "irins": "https://klsvdit.irins.org/profile/248887",
      "recognition": [
        "As Head of the Mathematics Research Centre at Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT), Dr. Meenal M. Kaliwal plays a key role in fostering research, innovation and academic excellence in Mathematics",
        "Published Patent titled \"Internet of Things (IoT) ENABLED WRONG POSTURE MONITORING AND ALERT SYSTEM\"",
        "Published more than 15 research articles in reputed journals and conference proceedings",
        "Attended and contributed to over 25 International and National conferences, workshops and symposia, fostering academic collaboration and knowledge exchange"
      ]
    },
    {
      "id": "f-g-s-kurdekar",
      "name": "Dr. G. S. Kurdekar",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Sc., Ph.D.",
      "qualifications": "M.Sc., Ph.D.",
      "image": "/FacultyCImages/DR_gurunath_kurudekar_BSH.jpeg",
      "email": "gsk@klsvdit.edu.in",
      "phone": "+91 96114 56880",
      "showPhone": false,
      "experience": "12 years",
      "description": "Dr. G. S. Kurdekar is faculty of the Department of Chemistry at KLS VDIT. His research interests include coordination compounds and their applications, as well as catalysis studies.He has 12 years of teaching experience Published 12 research article",
      "bio": "Dr. G. S. Kurdekar is faculty of the Department of Chemistry at KLS VDIT. His research interests include coordination compounds and their applications, as well as catalysis studies.He has 12 years of teaching experience Published 12 research article",
      "specializations": [
        "Coordination chemistry and catalysis"
      ],
      "areas": [
        "Coordination chemistry and catalysis"
      ],
      "courses": [
        "Applied Chemistry For Electronics And Communication (EC) Stream",
        "Applied Chemistry For Sustainable Structures And Material Design For Civil Stream",
        "Applied Chemistry For Advanced Metal Protection And Sustainable Energy System For Mechanical Stream",
        "Research Methodology"
      ],
      "publications": 11,
      "projects": 0,
      "linkedin": "",
      "irins": "",
      "recognition": [
        "information to be updated"
      ]
    },
    {
      "id": "f-vijaya-chitrali",
      "name": "Mrs. Vijaya Chitrali",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/vijaya_chaitrali_BSH.jpeg",
      "email": "vtc@klsvdit.edu.in",
      "phone": "+91 99724 08247",
      "showPhone": false,
      "experience": "18 years",
      "description": "Mrs. Vijaya Chitrali is an Assistant Professor in the Department of Mathematics at KLS VDIT. She is passionate about teaching and helping students build strong conceptual understanding. Committed to academic excellence, she encourages learners to enhance their knowledge, skills, and confidence, preparing them for successful academic and professional careers.",
      "bio": "Mrs. Vijaya Chitrali is an Assistant Professor in the Department of Mathematics at KLS VDIT. She is passionate about teaching and helping students build strong conceptual understanding. Committed to academic excellence, she encourages learners to enhance their knowledge, skills, and confidence, preparing them for successful academic and professional careers.",
      "specializations": [
        "Graph theory"
      ],
      "areas": [
        "Graph theory"
      ],
      "courses": [
        "Discrete Mathematical Structures",
        "Calculus & Linear Algebra",
        "Numerical Methods",
        "Mathematics For Computer Science"
      ],
      "publications": 0,
      "projects": 0,
      "linkedin": "",
      "irins": "https://klsvdit.irins.org/profile/149813",
      "recognition": [
        "Faculty Development Programme (FDP) - 5"
      ]
    },
    {
      "id": "f-akshata-b-patil",
      "name": "Mrs. Akshata B Patil",
      "designation": "Assistant professor",
      "role": "Assistant professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/Akshata_patil_BSH.jpeg",
      "email": "abp@klsvdit.edu.in",
      "phone": "+91 87226 28237",
      "showPhone": false,
      "experience": "10 years",
      "description": "Mrs. Akshata B. Patil is an Assistant Professor in the Department of Mathematics at KLS VDIT with 10 years of teaching experience. She specializes in Graph Theory and Numerical Methods and is committed to innovative teaching practices. Her ability to simplify complex concepts fosters student engagement, academic excellence, and a positive learning environment.",
      "bio": "Mrs. Akshata B. Patil is an Assistant Professor in the Department of Mathematics at KLS VDIT with 10 years of teaching experience. She specializes in Graph Theory and Numerical Methods and is committed to innovative teaching practices. Her ability to simplify complex concepts fosters student engagement, academic excellence, and a positive learning environment.",
      "specializations": [
        "Graph Theory and Numerical methods"
      ],
      "areas": [
        "Graph Theory and Numerical methods"
      ],
      "courses": [
        "Engineering Mathematics 1,2,3 And 4"
      ],
      "publications": 0,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/akshata-patil-712962277/",
      "irins": "https://klsvdit.irins.org/profile/248906",
      "recognition": [
        "information to be updated"
      ]
    },
    {
      "id": "f-satish-hande",
      "name": "Dr. Satish Hande",
      "designation": "Associate Professor",
      "role": "Associate Professor",
      "qualification": "M.Sc., Ph.D.",
      "qualifications": "M.Sc., Ph.D.",
      "image": "/FacultyCImages/DR_satish_hande_BSH.jpeg",
      "email": "sph@klsvdit.edu.in",
      "phone": "+91 80504 25503",
      "showPhone": false,
      "experience": "23 years",
      "description": "Dr. Satish Hande is an Associate Professor in the Department of Mathematics at KLS VDIT. With 23 years of teaching experience at undergraduate and postgraduate levels, he is passionate about mathematics education and research. His areas of interest include Graph Theory, Discrete Mathematics, and Linear Programming. He currently guides three Ph.D. scholars.",
      "bio": "Dr. Satish Hande is an Associate Professor in the Department of Mathematics at KLS VDIT. With 23 years of teaching experience at undergraduate and postgraduate levels, he is passionate about mathematics education and research. His areas of interest include Graph Theory, Discrete Mathematics, and Linear Programming. He currently guides three Ph.D. scholars.",
      "specializations": [
        "Graph theory",
        "Discrete mathematics",
        "Linear Programming"
      ],
      "areas": [
        "Graph theory",
        "Discrete mathematics",
        "Linear Programming"
      ],
      "courses": [
        "Engineering Mathematics-I, II, III, IV",
        "Linear Algebra",
        "Discrete Mathematics",
        "Graph Theory"
      ],
      "publications": 22,
      "projects": 0,
      "linkedin": "",
      "irins": "",
      "recognition": [
        "Life member of A member of Indian Society for Technical Education (ISTE)"
      ]
    },
    {
      "id": "f-m-s-sannaikar",
      "name": "Dr. M. S. Sannaikar",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Sc., Ph.D.",
      "qualifications": "M.Sc., Ph.D.",
      "image": "/FacultyCImages/DR_m_s_sannaikar_BSH.jpeg",
      "email": "mss@klsvdit.edu.in",
      "phone": "+91 81528 62489",
      "showPhone": false,
      "experience": "7 years",
      "description": "Dr. M. S. Sannaikar completed a Ph.D. on fluorescence spectroscopic studies of nanostructures and dyes (2019). M.Sc. in 2012. Recipient of the Young Scientist Travel Grant (France, 2018), K-SET qualified (2014), with over 25 research publications in the field of spectroscopy and nanoscience.",
      "bio": "Dr. M. S. Sannaikar completed a Ph.D. on fluorescence spectroscopic studies of nanostructures and dyes (2019). M.Sc. in 2012. Recipient of the Young Scientist Travel Grant (France, 2018), K-SET qualified (2014), with over 25 research publications in the field of spectroscopy and nanoscience.",
      "specializations": [
        "Fluorescence Spectroscopy",
        "Bio-Sensors",
        "Nanostructures and Density Functional Theory"
      ],
      "areas": [
        "Fluorescence Spectroscopy",
        "Bio-Sensors",
        "Nanostructures and Density Functional Theory"
      ],
      "courses": [
        "Engineering Physics For Computer Science And Engineering (CSE)",
        "Engineering Physics For Computer Science And Engineering - Artificial Intelligence And Machine Learning (CSE-AIML)",
        "Engineering Physics For Electrical And Electronics Engineering (EEE)"
      ],
      "publications": 25,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/m-s-sannaikar-719b9b70/",
      "irins": "https://klsvdit.irins.org/profile/271422",
      "recognition": [
        "Recipient of the Young Scientist Travel Grant (France,",
        "Member of Society of Photo-Optical Instrumentation Engineers (SPIE) Photonics",
        "Annual Member of Indian Science Congress Association (ISCA)",
        "Actively participated in Unnat Bharat Abhiyan (UBA) outreach activity"
      ]
    }
  ]
};

export default facultyData;

